// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={clerkPubKey}
      onSessionCreated={() => {
        // broadcast to other tabs that we signed in
        localStorage.setItem('clerk-signin', Date.now().toString());
      }}
      onSessionExpired={() => {
        // broadcast to other tabs that we signed out
        localStorage.setItem('clerk-signout', Date.now().toString());
      }}
    >
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals();
